export const formatMonth = (month) => {
  return month.replace(new Date().getFullYear(), '');
}

export const formatDate = (date) => {
  const dateParts = date.split('-');
  return dateParts[1] + '/' + dateParts[2] + '/' + dateParts[0];
}

export const formatMonthYear = (selectedMonth) => {
  let lastIndex = selectedMonth.length - 4;
  return selectedMonth.slice(0, lastIndex) + ' ' + selectedMonth.slice(lastIndex, selectedMonth.length);
}

export const formatDateTime = (date) => {
  const dateReplaced = date.replace('T', ' ');
  const dateParts = dateReplaced.split(' ');
  const timeParts = dateParts[1].split(':');
  return formatDate(dateParts[0]) + ' ' + timeParts[0] + ':' + timeParts[1];
}



// WEBPACK FOOTER //
// ./src/utils/format.js